import React, { useContext } from 'react';

import Web3context from '../contexts/Web3context.js'
import abi_1155 from '../contracts/IERC1155Game.json'

function Stake() {
  const web3context = useContext(Web3context)
  let { getWeb3 } = web3context;

  const onStake = async () => {
    try {
      const web3 = getWeb3;
      console.log("Network Id is", await web3.eth.net.getId());
      const accounts = await web3.eth.getAccounts();
      const contract_1155 = await new web3.eth.Contract(abi_1155.abi, "0xebe32c46234cA88A373a42Ed3916a7222B3E6BB0");

      // const txnhash = await contract_1155.methods.stake(item.id, ownerAddress, "data")
      //   .send({ from: accounts[0], gasPrice: "1000000000", gas: 35000 });
      // console.log(txnhash);
      // console.log(info);
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div>
      <div className="Ingredient_wrap">
        <div className="Ingredient_heading">
          <h1>STAKING</h1>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud </p>
        </div>
        <div className="Ingradient_tabs">
          <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item">
              <a className="nav-link active" data-toggle="tab" href="#stakeTabs" role="tab">STAKE</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#unlockTabs" role="tab">UNLOCK</a>
            </li>
          </ul>
          {/** <!-- Tab panes --> */}
          <div className="tab-content">
            <div className="tab-pane active" id="stakeTabs" role="tabpanel">
              <div className="selectDishSection">
                <label for="">SELECT DISH</label>
                <select name="" id="">
                  <option value="" selected></option>
                  <option value="Dish01">Dish 01</option>
                  <option value="Dish02">Dish 02</option>
                  <option value="Dish03">Dish 03</option>
                </select>
              </div>

              <div className="apyBootSection">
                <h2>APY BOOST : X %</h2>
                <button onClick={onStake}>Stake</button>
              </div>

            </div>
            <div className="tab-pane" id="unlockTabs" role="tabpanel">
              <div className="selectDishSection">
                <label for="">Select Dish</label>
                <select name="" id="">
                  <option value="selected" selected>Select</option>
                  <option value="Dish01">Dish 01</option>
                  <option value="Dish02">Dish 02</option>
                  <option value="Dish03">Dish 03</option>
                </select>
              </div>

              <div className="apyBootSection">
                <button>UNLOCK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Stake;
